export const actions = {
  set_state: 'log_activity/set_state',
  get_log: 'log_activity/get_activity'
}
